(function () {
    'use strict';

    angular
        .module('franchiser', [
            'franchiser.constants',
            'franchiser.components',
            'franchiser.directives',
            'franchiser.filters',
            'franchiser.interceptors',
            'franchiser.routes',
            'franchiser.services'
        ])
        .run(run);

    /** @ngInject */
    function run() {

    }
})();